/**
 * `2026-10-13` → `13 October 2026`.
 *
 * Fixed to en-GB rather than the visitor's locale: the date is rendered on the
 * server and hydrated on the client, and a locale-dependent string is the
 * classic way to get a hydration mismatch on a static page.
 */
export const formatPostDate = (iso: string) => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
};

/** `1` → `01`. The journal numbers everything in two digits. */
export const pad2 = (n: number) => (n < 10 ? `0${n}` : String(n));
